import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import "./App.css";
import InvoiceList from "./pages/Invoices/Listing/InvoiceList";
import { useAuth } from "oidc-react";
import Login from "./pages/Login";
import InvoiceDetail from "./pages/Invoices/Detail/InvoiceDetail";
import LoginCallback from "./components/LoginCallback";
import BasicLayout from "./components/BasicLayout";
import EmailQueues from "./pages/Email/Listing/EmailQueues";
import EmailQueueDetails from "./pages/Email/Detail/EmailQueueDetails";
import MappedKvps from "./pages/Admin/Mappedkvps/MappedKvps";
import MailboxUsers from "./pages/Admin/MailboxUsers/MailboxUsers";
import OCRConfiguration from "./pages/Admin/OCRConfiguration/OCRConfiguration";
import Reports from "./pages/Reports/Reports";
import UserGuide from "./pages/UserGuide/UserGuide";
import ReleaseNotes from "./pages/ReleaseNotes/ReleaseNotes";
import DocumentLabels from "./pages/Admin/DocumentLabels";
import Admin from "./pages/Admin/Whitelist/EmailWhitelist";
import AdminSupplier from "./pages/Admin/Supplier/Listing/AdminSupplier";
import AdminSupplierDetail from "./pages/Admin/Supplier/Detail/AdminSupplierDetail";
import SharedService from "./services/shared/service";
import { HelmetProvider } from "react-helmet-async";
import { useHandleAuthentication } from "./handler/authHandler";
import AccessDenied from "./pages/Generic/AccessDenied";

const App = () => {
  const { userData } = useAuth();
  const [currentItemIndex, setCurrentItemIndex] = useState(0);
  const [invoiceData, setinvoiceData] = useState([]);
  const [admin, setAdmin] = useState(false);
  const [adminData, setAdminData] = useState([]);

  const { handleAuthentication } = useHandleAuthentication();

  const [listPagination, setlistPagination] = useState({
    totalItemCount: 0,
    pageSize: 10,
    pageNumber: 1,
  });

  const {
    REACT_APP_SETTINGS_PRIMARY_BRAND_COLOR,
    REACT_APP_SETTINGS_SECONDARY_BRAND_COLOR,
  } = process.env;

  const hasAdminPrivilege = async (accessToken) => {
    try {
      const response = await SharedService.get({
        token: accessToken,
        url: "user",
      });
      if (response) {
        let adminAccess = response.isAdmin;
        setAdmin(adminAccess);
        setAdminData(response);
      }
    } catch (error) {}
  };

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--primary-color",
      REACT_APP_SETTINGS_PRIMARY_BRAND_COLOR,
    );
    document.documentElement.style.setProperty(
      "--secondary-color",
      REACT_APP_SETTINGS_SECONDARY_BRAND_COLOR,
    );
  }, []);

  useEffect(() => {
    const token = userData?.access_token;

    if (token) {
      if (window.location.pathname !== "/access-denied") {
        hasAdminPrivilege(token);
      }

      handleAuthentication(userData);
    }
  }, [userData]);

  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route
            path="/"
            element={<BasicLayout admin={admin} adminData={adminData} />}
          >
            <Route
              path="invoice"
              element={
                <InvoiceList
                  setlistPagination={setlistPagination}
                  listPagination={listPagination}
                  invoiceData={invoiceData}
                  setinvoiceData={setinvoiceData}
                  currentItemIndex={currentItemIndex}
                />
              }
            />

            <Route path="emailqueues">
              <Route path="details/:id" element={<EmailQueueDetails />} />
              <Route index element={<EmailQueues />} />
            </Route>

            <Route path="admin">
              <Route path="permitted-emails" element={<Admin />} />
              <Route path="mapped-kvps" element={<MappedKvps />} />
              <Route path="mailbox-users" element={<MailboxUsers />} />
              <Route path="ocr-configuration" element={<OCRConfiguration />} />
              <Route
                path="document-labels-mapping"
                element={<DocumentLabels />}
              />
              <Route path="suppliers">
                <Route path="details/:id" element={<AdminSupplierDetail />} />
                <Route index element={<AdminSupplier />} />
              </Route>
            </Route>

            <Route index element={<Navigate to="/invoice" />} />

            <Route path="report" element={<Reports />} />

            <Route path="user-guide" element={<UserGuide admin={admin} />} />

            <Route path="release-notes" element={<ReleaseNotes />} />
          </Route>

          <Route path="signin-oidc" element={<LoginCallback />} />
          <Route path="login" element={<Login />} />
          <Route path="access-denied" element={<AccessDenied />} />
          <Route
            path="details/:id"
            element={
              <InvoiceDetail
                setlistPagination={setlistPagination}
                listPagination={listPagination}
                setinvoiceData={setinvoiceData}
                invoiceData={invoiceData}
                currentItemIndex={currentItemIndex}
                setCurrentItemIndex={setCurrentItemIndex}
              />
            }
          />
        </Routes>
      </Router>
    </HelmetProvider>
  );
};

export default App;
